import { render, staticRenderFns } from "./Disloc.vue?vue&type=template&id=24edf8c7&scoped=true&"
import script from "./Disloc.vue?vue&type=script&lang=js&"
export * from "./Disloc.vue?vue&type=script&lang=js&"
import style0 from "./Disloc.vue?vue&type=style&index=0&id=24edf8c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edf8c7",
  null
  
)

export default component.exports